import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';

interface AuthLogin {
  email: string;
  password: string;
}

export function appLogin(payload: AuthLogin) {
  return api.baseClient.post(`${CONSUMER_API_PATH}/login/`, payload);
}

export async function sendResetPasswordEmail(email: string) {
  return api.baseClient.post(`${CONSUMER_API_PATH}/password-forget-begin/`, { email });
}
